import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UploadForm from './UploadForm';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import DashboardPage from './DashboardPage';
import DatasetPage from './DatasetPage';
import ModelsPage from './ModelsPage';
import ModelsScreen from './ModelsScreen';
import UsersPage from './UsersPage';
import SettingsPage from './SettingsPage';
import PaymentsPage from './PaymentsPage';
import NotificationsPage from './NotificationsPage';
import AlertsPage from './AlertsPage';
import AdsPage from './AdsPage';

const TabNavigation = ({ onLogout }) => {
  const location = useLocation();
  
  const tabs = [
    { path: '/dashboard', label: 'Dashboard', component: DashboardPage },
    {
      label: 'Models',
      submenu: [
        { path: '/dashboard/dataset', label: 'Dataset', component: DatasetPage },
        { path: '/dashboard/models', label: 'Models', component: ModelsPage },
        { path: '/dashboard/models/test', label: 'AI Model Testing', component: ModelsScreen },
      ],
    },
    { path: '/dashboard/ads', label: 'ADs', component: AdsPage },
    { path: '/dashboard/users', label: 'Users', component: UsersPage },
    { path: '/dashboard/settings', label: 'Settings', component: SettingsPage },
    { path: '/dashboard/payments', label: 'Payments', component: PaymentsPage },
    { path: '/dashboard/notifications', label: 'Notifications', component: NotificationsPage },
    { path: '/dashboard/alerts', label: 'Alerts', component: AlertsPage }
  ];

  return (
    <div className="container">
      <div className="top-bar">
        <div className="top-bar-content">
          <h1 className="top-bar-title">AarogAI Admin Panel</h1>
          <button onClick={onLogout} className="btn btn-secondary">
            Logout
          </button>
        </div>
      </div>

      {/* Inline styles for dropdown, you can move to CSS file */}
      <style>{`
        .tab-navigation { display: flex; gap: 1rem; position: relative; overflow: visible !important; }
        .tab { position: relative; padding: 0.5rem 1rem; cursor: pointer; text-decoration: none; color: inherit; }
        .tab.active { font-weight: bold; border-bottom: 2px solid #007bff; }
        .tab.has-submenu:hover .submenu { display: block; }
        .submenu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          background: white;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          min-width: 180px;
          z-index: 9999; /* Increased for visibility */
          border: 1px solid #e0e0e0; /* Subtle border for clarity */
        }
        .submenu-link {
          display: block;
          padding: 0.5rem 1rem;
          color: #333;
          text-decoration: none;
          white-space: nowrap;
        }
        .submenu-link.active, .submenu-link:hover {
          background: #f0f0f0;
          color: #007bff;
        }
      `}</style>

      <div className="tab-navigation">
        {tabs.map((tab) =>
          tab.submenu ? (
            <div key={tab.label} className="tab has-submenu">
              {tab.label}
              <div className="submenu">
                {tab.submenu.map((sub) => (
                  <Link
                    key={sub.path}
                    to={sub.path}
                    className={`submenu-link ${location.pathname === sub.path ? 'active' : ''}`}
                  >
                    {sub.label}
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <Link
              key={tab.path}
              to={tab.path}
              className={`tab ${location.pathname === tab.path ? 'active' : ''}`}
            >
              {tab.label}
            </Link>
          )
        )}
      </div>

      <div className="tab-content">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dataset" element={<DatasetPage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/models/test" element={<ModelsScreen />} />
          <Route path="/ads" element={<AdsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
        </Routes>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  return (
    <>
      <TabNavigation onLogout={handleLogout} />
    </>
  );
};

export default Dashboard; 